/**
 * Maps backend activity data to ActivityListWidget view model.
 * Isolated so backend contract changes don't require rewriting UI (WID-09).
 */
import { ACTIVITY_TYPE_CONFIG, ALERT_TYPES } from '../constants';
import { formatTimeAgo } from '../../../../../../utils/dateFormatters';

const DEFAULT_TYPE = 'call';

export const mapActivityItem = (raw) => {
  const type = ACTIVITY_TYPE_CONFIG[raw?.type] ? raw.type : DEFAULT_TYPE;
  return {
    id: raw?.id ?? '',
    type,
    title: raw?.title ?? raw?.description ?? 'Title of the activity',
    description: raw?.description ?? raw?.content ?? '',
    author: raw?.author ?? raw?.userName ?? '',
    timestamp: raw?.timestamp ?? raw?.date ?? raw?.createdAt ?? '',
    timeAgo: raw?.timeAgo ?? formatTimeAgo(raw?.timestamp ?? raw?.date),
    alerts: normalizeAlerts(raw?.alerts ?? raw?.criticalState),
    metadata: {
      userId: raw?.userId ?? raw?.metadata?.userId ?? '',
      sentiment: raw?.sentiment ?? raw?.metadata?.sentiment,
      assignedTasks: raw?.assignedTasks ?? raw?.metadata?.assignedTasks ?? 0,
      hasRecording: raw?.hasRecording ?? raw?.metadata?.hasRecording ?? false,
      hasExternalLink: raw?.hasExternalLink ?? raw?.metadata?.hasExternalLink ?? false,
      direction: raw?.direction ?? raw?.metadata?.direction,
      duration: raw?.duration ?? raw?.metadata?.duration ?? '',
      flagged: raw?.flagged ?? raw?.metadata?.flagged ?? false,
      commentsCount: raw?.commentsCount ?? raw?.metadata?.commentsCount ?? 0,
      attachmentsCount: raw?.attachmentsCount ?? raw?.metadata?.attachmentsCount ?? 0,
      linkCount: raw?.linkCount ?? raw?.metadata?.linkCount ?? 0,
    },
  };
};

export const mapActivityListData = (rawData) => {
  if (!rawData) return { title: '', items: [] };
  const items = Array.isArray(rawData.items) ? rawData.items : [];
  return {
    title: rawData.title ?? 'Activity',
    items: items.map(mapActivityItem),
  };
};

function normalizeAlerts(alerts) {
  if (!alerts) return [];
  const arr = Array.isArray(alerts) ? alerts : [alerts];
  return arr
    .map((a) => {
      if (typeof a === 'string') {
        if (a.toLowerCase().includes('expired')) return { type: ALERT_TYPES.EXPIRED, message: a };
        return { type: ALERT_TYPES.NEEDS_ATTENTION, message: a };
      }
      return {
        type: a.type === 'expired' ? ALERT_TYPES.EXPIRED : ALERT_TYPES.NEEDS_ATTENTION,
        message: a.message ?? a.description ?? '',
      };
    })
    .filter((a) => a.message);
}
